module.exports = __webpack_public_path__ + "static/chonky-breakdown-a17a42c9aa29e04855a3a5855c0f64ce.jpg";